import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import VectorImg from "../../assets/images/icon-user-default.png";
import Modal from "react-bootstrap/Modal";
import Axe from "../../assets/images/sidebar/icons/axeMark.svg";
import Phonetwentyfour from "../../assets/images/phonetwentyfour.svg";
import Phone from "../../assets/images/phone.svg";
import ProfileBlue from "../../assets/images/profileblue.svg";
import Lead from "../../assets/images/lead.svg";
import TotalAdmin from "../../assets/images/totaladmin.svg";
import TotalEmail from "../../assets/images/totalemailsend.svg";
import Totalinstall from "../../assets/images/Totalinstalls.svg";
import Newreturningusers from "../../assets/images/neworreturninguser.svg";
import ActiveUsers from "../../assets/images/activeusers.svg";
import Registered from "../../assets/images/registered.svg";
import Location from "../../assets/images/Location.svg";

import DeviceVersion from "../../assets/images/deviceversion.svg";
import ScreenTime from "../../assets/images/screentme.svg";
import { useNavigate, useLocation } from "react-router-dom";

import {
  multipartPostCallWithErrorResponse,
  postWithAuthCallWithErrorResponse,
  simpleGetCallWithToken,
} from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { ToastMsg } from "../TostMsg";
import { Form } from "react-bootstrap";
import { add } from "lodash";
// import { useNavigate } from "react-router-dom";
import Phonebookdash from "../CRMphonebook/Phonebookdash";

const CRMDashboard = () => {
  const { sidebar, setSidebar, Dark, setDark, userData, permissions } =
    useContext(AppContext);
  const [key, setKey] = useState("personalDetails");
  console.log("Key data >>>>>>>>>>", key);
  const [inputValue, setInputValue] = useState("");
  const navigate = useNavigate();
  const locationState = useLocation();
// Default tab state ko 0 rakhein
  // const [activeTab, setActiveTab] = useState(0);

  const [departmentlist, setDepartmentlist] = useState([]);
  const [designationsname, setDesignationsname] = useState([]);
  const [role, setRole] = useState([]);
  const [employeeattlist, setEmployeeattlist] = useState([]);
  const [location, setLocation] = useState([]);
  const [shift, setShift] = useState([]);
  const [validated, setValidated] = useState(false);
  const [showPersonal, setShowPersonal] = useState(false);
  // const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState("");
  // const [errorMessage2, setErrorMessage2] = useState('');
  const [errorMessage3, setErrorMessage3] = useState("");
  const [errorMessage4, setErrorMessage4] = useState("");
  const [errorMessage5, setErrorMessage5] = useState("");
  const [errorMessage6, setErrorMessage6] = useState("");
  const [errorMessage7, setErrorMessage7] = useState("");
  const [addEmply, setAddEmply] = useState({
    EmployeePhoto: "",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    DateOfBirth: "",
    FatherName: "",
    MothersName: "",
    Religion: "",
    Nationality: "",
    Gender: "",
    BloodGroup: "",
    IdentificationMark: "",
    MaritalStatus: "",
    EmployeeCode: 0,
    GSMIId: "",
    TranscardId: "",
    WorkEmail: "",
    OtherEmail: "",
    MobilePhone: "",
    EmergencyContact: "",
    EmergencyContactPerson: "",
    HomePhone: "",
    Extension: "",
    Address: "",
    City: "",
    State: "",
    ZipCode: "",
    PermanentAddress: "",
    Country: "",
    DepartmentId: "",
    DesignationId: "",
    LocationId: "",
    ShiftId: "",
    Grade: "",
    NatureOfPost: "",
    DateOfJoining: "",
    ReportingId: "",
    RoleId: "",
    WorkTelephone: "",
    TeamId: 0,
  });
  console.log(addEmply, "addemployee");
  const [error, setError] = useState({
    EmployeePhoto: "",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    DateOfBirth: "",
    FatherName: "",
    MothersName: "",
    Religion: "",
    Nationality: "",
    Gender: "",
    BloodGroup: "",
    IdentificationMark: "",
    MaritalStatus: "",
    EmployeeCode: "",
    GSMIId: "",
    TranscardId: "",
    WorkEmail: "",
    OtherEmail: "",
    MobilePhone: "",
    EmergencyContact: "",
    EmergencyContactPerson: "",
    HomePhone: "",
    Extension: "",
    Address: "",
    City: "",
    State: "",
    ZipCode: "",
    PermanentAddress: "",
    Country: "",
    DepartmentId: "",
    DesignationId: "",
    LocationId: "",
    ShiftId: "",
    Grade: "",
    NatureOfPost: "",
    DateOfJoining: "",
    ReportingId: "",
    RoleId: "",
    WorkTelephone: "",
    TeamId: "",
  });
  //   useEffect(()=>{
  //     simpleGetCallWithToken(ApiConfig.GET_OWNER_NAMES_MODEL_OPTIONS)
  //     .then(res=>{
  // console.log("eee success")
  // setEmployeeattlist(res?.Data)
  // console.log('eeeee list : ', employeeattlist)
  //     })
  //   },[])

  useEffect(() => {
    Promise.all([
      simpleGetCallWithToken(ApiConfig.GETDEPARTMENT_LIST),
      simpleGetCallWithToken(ApiConfig.DESIGNATION_NAME),
      simpleGetCallWithToken(ApiConfig.ROLES_LIST),
      // postWithAuthCallWithErrorResponse(ApiConfig.TEAM_HEAD_lIST),
      simpleGetCallWithToken(ApiConfig.GET_OWNER_NAMES_MODEL_OPTIONS),
      simpleGetCallWithToken(ApiConfig.GET_LOCATION),
      simpleGetCallWithToken(ApiConfig.GET_SHIFT_LIST),
    ])
      .then(
        ([
          responses1,
          response2,
          response3,
          response4,
          response5,
          response6,
        ]) => {
          setDepartmentlist(responses1.Data);
          setDesignationsname(response2.Data);
          setRole(response3.Data);
          setEmployeeattlist(response4.Data);
          setLocation(response5.Data);
          setShift(response6.Data);
        }
      )
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (locationState.state && locationState.state.activeTab !== undefined) {
      setActiveTab(locationState.state.activeTab);
    }
  }, [locationState.state]);

  const handleScreenNextTab = (e) => {
    e.preventDefault();
    if (key === "personalDetails") {
      if (addEmply.EmployeePhoto === "") {
        setError({
          ...error,
          EmployeePhoto: "Please upload your profile picture",
        });
        return;
      }
      if (addEmply.FirstName.length === 0) {
        setError({
          ...error,
          FirstName: "Enter first Name",
        });
        return;
      }
      // if (addEmply.MiddleName.length === 0) {
      //   setError({
      //     ...error,
      //     MiddleName: "Enter Middle Name",
      //   });
      //   return;
      // }
      if (addEmply.LastName.length === 0) {
        setError({
          ...error,
          LastName: "Enter Last Name ",
        });
        return;
      }
      if (addEmply.DateOfBirth.length === 0) {
        setError({
          ...error,
          DateOfBirth: "Enter Date Of Birth",
        });
        return;
      }
      if (addEmply.FatherName.length === 0) {
        setError({
          ...error,
          FatherName: "Enter Father Name",
        });
        return;
      }
      if (addEmply.MothersName.length === 0) {
        setError({
          ...error,
          MothersName: "Enter Mother Name ",
        });
        return;
      }
      if (addEmply.Religion.length === 0) {
        setError({
          ...error,
          Religion: "Please Enter Religion",
        });
        return;
      }
      if (addEmply.Nationality.length === 0) {
        setError({
          ...error,
          Nationality: " Please Enter Nationality",
        });
        return;
      }
      if (addEmply.Gender.length === 0) {
        setError({
          ...error,
          Gender: "Please Enter Gender",
        });
        return;
      }
      if (addEmply.MaritalStatus.length === 0) {
        setError({
          ...error,
          MaritalStatus: "Please Enter MaritalStatus",
        });
        return;
      } else {
        setKey("contactDetails");
      }
    }
    if (key === "contactDetails") {
      const regex = /^[a-zA-Z0-9.]+@(?:[a-zA-Z0-9.]+\.)+[A-Za-z]+$/;

      if (!regex.test(addEmply.WorkEmail)) {
        setError({ ...error, WorkEmail: "Enter Valid Email ID " });
        return;
      }

      if (!regex.test(addEmply.OtherEmail)) {
        setError({ ...error, OtherEmail: "Enter Valid Email ID " });
        return;
      }
      if (addEmply.MobilePhone.length === 0) {
        setError({
          ...error,
          MobilePhone: "Please Enter Mobile Number",
        });
        return;
      }
      if (addEmply.Address.length === 0) {
        setError({
          ...error,
          Address: "Please Enter Address",
        });
        return;
      }
      if (addEmply.City.length === 0) {
        setError({
          ...error,
          City: "Please Enter City",
        });
        return;
      }
      if (addEmply.State.length === 0) {
        setError({
          ...error,
          State: "Please Enter State",
        });
        return;
      }

      if (addEmply.Country.length === 0) {
        setError({
          ...error,
          Country: "Please Enter Country",
        });
        return;
      } else {
        setKey("professionalDetails");
      }
    }
    if (key === "professionalDetails") {
      if (addEmply.DepartmentId.length === 0) {
        setError({
          ...error,
          DepartmentId: "Please Select Department",
        });
        return;
      }
      if (addEmply.DesignationId.length === 0) {
        setError({
          ...error,
          DesignationId: "Please Select Designation ",
        });
        return;
      }
      if (addEmply.LocationId.length === 0) {
        setError({
          ...error,
          LocationId: "Please Select Location",
        });
        return;
      }
      if (addEmply.ShiftId.length === 0) {
        setError({
          ...error,
          ShiftId: "Please Select Shift",
        });
        return;
      }
      if (addEmply.Grade.length === 0) {
        setError({
          ...error,
          Grade: "Please Select Grade",
        });
        return;
      }
      if (addEmply.NatureOfPost.length === 0) {
        setError({
          ...error,
          NatureOfPost: "Please Select Nature Of Post ",
        });
        return;
      }
      if (addEmply.DateOfJoining.length === 0) {
        setError({
          ...error,
          DateOfJoining: "Please Select Date Of Joining ",
        });
        return;
      }
      if (addEmply.ReportingId.length === 0) {
        setError({
          ...error,
          ReportingId: "Please Select Reporting",
        });
        return;
      }
      if (errorMessage === "") {
        return;
      } else {
        AddEmployeeApi();
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const regex = /^[a-zA-Z ]*$/; // Regular expression to allow only alphabets

    const usercopy = { ...addEmply };
    const errMsgcopy = { ...error };
    usercopy[name] = value;
    errMsgcopy[name] = "";
    setError(errMsgcopy);
    setAddEmply(usercopy);
    if (name == "FirstName") {
      if (!regex.test(value)) {
        setErrorMessage("Only alphabets are allowed.");
      } else {
        setErrorMessage("");
        setInputValue(value);
      }
    }

    // if (name == 'MiddleName') {
    //   if (!regex.test(value)) {
    //     setErrorMessage2('Only alphabets are allowed.');
    //   } else {
    //     setErrorMessage2('');
    //     setInputValue(value);
    //   }
    // };

    if (name == "LastName") {
      if (!regex.test(value)) {
        setErrorMessage3("Only alphabets are allowed.");
      } else {
        setErrorMessage3("");
        setInputValue(value);
      }
    }

    if (name == "FatherName") {
      if (!regex.test(value)) {
        setErrorMessage4("Only alphabets are allowed.");
      } else {
        setErrorMessage4("");
        setInputValue(value);
      }
    }

    if (name == "MothersName") {
      if (!regex.test(value)) {
        setErrorMessage5("Only alphabets are allowed.");
      } else {
        setErrorMessage5("");
        setInputValue(value);
      }
    }

    if (name == "Religion") {
      if (!regex.test(value)) {
        setErrorMessage6("Only alphabets are allowed.");
      } else {
        setErrorMessage6("");
        setInputValue(value);
      }
    }

    if (name == "Nationality") {
      if (!regex.test(value)) {
        setErrorMessage7("Only alphabets are allowed.");
      } else {
        setErrorMessage7("");
        setInputValue(value);
      }
    }
  };

  const AddEmployeeApi = (e) => {
    let fromdata = new FormData();
    fromdata.append("EmployeePhoto", addEmply.EmployeePhoto);
    fromdata.append("FirstName", addEmply.FirstName);
    fromdata.append("MiddleName", addEmply.MiddleName);
    fromdata.append("LastName", addEmply.LastName);
    fromdata.append("DateOfBirth", addEmply.DateOfBirth);
    fromdata.append("FatherName", addEmply.FatherName);
    fromdata.append("MothersName", addEmply.MothersName);
    fromdata.append("Religion", addEmply.Religion);
    fromdata.append("Nationality", addEmply.Nationality);
    fromdata.append("Gender", addEmply.Gender);
    fromdata.append("BloodGroup", addEmply.BloodGroup);
    fromdata.append("IdentificationMark", addEmply.IdentificationMark);
    fromdata.append("MaritalStatus", addEmply.MaritalStatus);
    fromdata.append("EmployeeCode", addEmply.EmployeeCode);
    fromdata.append("GSMIId", addEmply.GSMIId);
    fromdata.append("TranscardId", addEmply.TranscardId);
    fromdata.append("WorkEmail", addEmply.WorkEmail);
    fromdata.append("MobilePhone", addEmply.MobilePhone);
    fromdata.append("EmergencyContact", addEmply.EmergencyContact);
    fromdata.append("EmergencyContactPerson", addEmply.EmergencyContactPerson);
    fromdata.append("HomePhone", addEmply.HomePhone);
    fromdata.append("Extension", addEmply.Extension);
    fromdata.append("Address", addEmply.Address);
    fromdata.append("City", addEmply.City);
    fromdata.append("State", addEmply.State);
    fromdata.append("ZipCode", addEmply.ZipCode);
    fromdata.append("Country", addEmply.Country);
    fromdata.append("DepartmentId", addEmply.DepartmentId);
    fromdata.append("DesignationId", addEmply.DesignationId);
    fromdata.append("PermanentAddress", addEmply.PermanentAddress);
    fromdata.append("LocationId", addEmply.LocationId);
    fromdata.append("ShiftId", addEmply.ShiftId);
    fromdata.append("Grade", addEmply.Grade);
    fromdata.append("NatureOfPost", addEmply.NatureOfPost);
    fromdata.append("DateOfJoining", addEmply.DateOfJoining);
    fromdata.append("ReportingId", addEmply.ReportingId);
    fromdata.append("RoleId", addEmply.RoleId);
    fromdata.append("WorkTelephone", addEmply.WorkTelephone);
    fromdata.append("TeamId", addEmply.TeamId);
    multipartPostCallWithErrorResponse(ApiConfig.EMPLOYE_ADDED, fromdata)
      .then((res) => {
        console.log(res);
        if (res.json && res.json?.Success === true) {
          ToastMsg("success", res.json.Message);
          navigate("/List");
        } else {
          ToastMsg("error", res.json.Message);
        }
      })
      .catch((err) => console.log(err));

    setValidated(true);
  };

  const handlezPrevious = (key) => {
    setKey("contactDetails");
  };

  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const categories = [
    "Total",
    "IOT",
    "Services",
    "Booking",
    "Social",
    "Commerce",
    "Health",
    "Education",
    "Donation",
    "Game",
    "Transport",
    "Food Delivery",
    "Real Estate",
    "Productivity",
    "Suggestion",
  ];

  const tabstwo = [
    {
      title: "CRM",
      content: (
        <div>
          {" "}
          <div className="boxrow col-12 mt-4">
            <div className="box">
              <div className="boxrow">
                <img src={Lead} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">Total Installs</p>
                  <p className="text2">21568</p>
                </div>
              </div>
            </div>
            <div className="box">
              <div className="boxrow">
                <img src={TotalAdmin} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">New/Returning Users</p>
                  <p className="text2">21632</p>
                </div>
              </div>
            </div>
            <div className="box">
              <div className="boxrow">
                <img src={TotalEmail} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">Active Users</p>
                  <p className="text2">03</p>
                </div>
              </div>
            </div>
          </div>
          <div className="table-wrapper-main mb-4">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Category</th>
                  {months.map((month, index) => (
                    <th key={index}>{month}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {categories.map((category, index) => (
                  <tr key={index} className="table-row-main">
                    <td>{category}</td>
                    {months.map((month, index) => (
                      <td key={index}>Value</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ),
    },
    {
      title: "Analytics",
      content: (
        <div>
          {" "}
          <div className="boxrow col-12 mt-4">
            <div className="box ">
              <div className="boxrow">
                <img src={Totalinstall} className="ml-2" />
                <div className="ml-2">
                  <p className="text1">Total Installs</p>
                  <p className="text2">21568</p>
                </div>
              </div>
            </div>
            <div className="box ">
              <div className="boxrow">
                <img src={Newreturningusers} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">New/Returning Users</p>
                  <p className="text2">21632</p>
                </div>
              </div>
            </div>
            <div className="box ">
              <div className="boxrow">
                <img src={ActiveUsers} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">Active Users</p>
                  <p className="text2">03</p>
                </div>
              </div>
            </div>
            <div className="box ">
              <div className="boxrow">
                <img src={Registered} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">Registered</p>
                  <p className="text2">12853</p>
                </div>
              </div>
            </div>
          </div>
          <div className="boxrow col-12 mt-4">
            <div className="box ">
              <div className="boxrow">
                <img src={Location} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">Location</p>
                  <p className="text2">4</p>
                </div>
              </div>
            </div>
            <div className="box ">
              <div className="boxrow">
                <img src={DeviceVersion} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">Device/Version</p>
                  <p className="text2">13285</p>
                </div>
              </div>
            </div>
            <div className="box ">
              <div className="boxrow">
                <img src={ScreenTime} color="pink" className="ml-2" />
                <div className="ml-2">
                  <p className="text1">ScreenTime</p>
                  <p className="text2">13224</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const [activeTabtwo, setActiveTabtwo] = useState(0);

  const handleTabClicktwo = (index) => {
    setActiveTabtwo(index);
  };



  const tabs = [
    {
      title: "Phonebook",
      permissions:"View Phonebook Dashboard",
      content: (
        <div>
          <Phonebookdash />
        </div>
      ),
    },
    {
      title: "Office caller",
       permissions:"View Office Caller Dashboard",
      content: (
        <div>
          <div className="mt-2">
            <div>
              <div className="tab-buttonstwo  ">
                {tabstwo.map((tab, index) => (
                  <button
                    key={index}
                    onClick={() => handleTabClicktwo(index)}
                   className={index === activeTabtwo ? "active-tab" : "inactive-tab"}
                  >
                    {tab.title}
                  </button>
                ))}
              </div>
              <div className="tab-content">{tabstwo[activeTabtwo].content}</div>
            </div>
          </div>
        </div>
      ),
    },
  ];
const allowedTabs = tabs.filter((tab) => permissions && permissions[tab.permissions]);

  return (
    <div>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content">
          <div className="sub-header-role ">
            <h6 className="mt-2">DashBoard</h6>
          </div>

          <div className="mt-2 col-12">
            {allowedTabs.length > 0 ? (
            <div>
              <div className="tab-buttons d-flex flex-wrap ">
                {allowedTabs.map((tab, index) => (
                  <button
                    key={index}
                    onClick={() => handleTabClick(index)}
                    className={
                      index === activeTab ? "active-tab" : "inactive-tab"
                    }
                  >
                    {tab.title}
                  </button>
                ))}
              </div>
              <div className="tab-content mt-3">
               {allowedTabs[activeTab]?.content}
            </div>
            </div>
            ) : (
            <div className="text-center">No tabs authorized for this user.</div>
            )}
          </div>
        </div>
      </div>

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
        show={showPersonal}
        onHide={() => setShowPersonal(false)}
      >
        <Modal.Header>
          <Modal.Title>
            <label htmlFor="" className="create-role-text">
              Import Employees
            </label>
          </Modal.Title>
          <div className="rightAxe">
            <img src={Axe} alt="" onClick={() => setShowPersonal(false)} />
          </div>
        </Modal.Header>
        <div className="hr-line-modal">
          <hr style={{ margin: "0" }} />
        </div>

        <Modal.Body>
          <label>Import your file</label>
          <input
            type="file"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            id="imgHolder"
            required
            className="form-control tasKCategory1"
            name="EmployeePhoto"
            onChange={(e) => {
              const selectedFile = e.target.files[0];
              // Check if a file is selected
              if (selectedFile) {
                console.log("Selected file size:", selectedFile.size);
                // Check if the file size exceeds 4MB
                if (selectedFile.size > 4 * 1024 * 1024) {
                  console.log("File size exceeds 4MB");
                  setError({
                    ...error,
                    EmployeePhoto: "File size should not exceed 4MB.",
                  });
                } else {
                  setAddEmply({
                    ...addEmply,
                    EmployeePhoto: e.target.files[0],
                  });
                  setError({
                    ...error,
                    EmployeePhoto: "",
                  });
                }
              }
            }}

            // required={!addEmply.EmployeePhoto ? true : false}
          />
        </Modal.Body>

        <div className="hr-line-modal-1">
          <hr style={{ margin: "0" }} />
        </div>
        <Modal.Footer className="model-footer-arbaz-responsive">
          <div className="Bottom-btn-arbaz-responsive">
            <button
              className="modal-cancel-btn branchList-modal-cancel-btn-arbaz-responsive"
              onClick={() => setShowPersonal(false)}
            >
              Cancel
            </button>
            <button className="modal-create-btn branchList-modal-cancel-btn-arbaz-responsive">
              Update
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CRMDashboard;
